const DICOM_EXTENSIONS = /\.(dicom|dcm)$/i;
const ROTATABLE_EXTENSIONS = /\.(jpe?g|png)$/i;

/**
 * True when an X-ray can be rotated by the canvas-based rotation pipeline.
 * Covers both pending uploads (decided by the in-memory File's MIME and name)
 * and already-saved X-rays (decided by the persisted filename extension).
 */
export function isXrayRotatable(xray: {
  id?: string;
  filename?: string;
  originalFilename?: string | null;
  file?: File;
}): boolean {
  // Pending (new) upload: gate on the File object.
  if (xray.file) {
    if (xray.filename && DICOM_EXTENSIONS.test(xray.filename)) return false;
    if (xray.file.name && DICOM_EXTENSIONS.test(xray.file.name)) return false;
    if (xray.file.type && !xray.file.type.startsWith('image/')) return false;
    return true;
  }

  // Existing (already uploaded) X-ray: gate on the filename extension only.
  // Only JPEG and PNG are rotatable via canvas.
  if (!xray.id) return false;
  const name = xray.originalFilename ?? xray.filename ?? '';
  if (DICOM_EXTENSIONS.test(name)) return false;
  return ROTATABLE_EXTENSIONS.test(name);
}
